{
  "scheduling": "予約管理",
  "date": "日付",
  "time": "時間",
  "duration": "所要時間",
  "provider": "担当医",
  "reason": "受診理由",
  "status": "ステータス",
  "statusOptions": {
    "scheduled": "予約済み",
    "confirmed": "確認済み",
    "arrived": "来院済み",
    "checked-in": "受付済み",
    "in-progress": "診察中",
    "completed": "完了",
    "cancelled": "取消",
    "no-show": "未来院"
  },
  "coverageScope": {
    "panel": "担当患者",
    "unit": "病棟",
    "facility": "施設全体"
  },
  "coverageScopeDescription": {
    "panel": "対象医師の担当患者のみ。",
    "unit": "対象医師の担当病棟。",
    "facility": "施設全体 — 通常はオンコール体制。"
  },
  "dayShort": {
    "0": "日",
    "1": "月",
    "2": "火",
    "3": "水",
    "4": "木",
    "5": "金",
    "6": "土"
  },
  "blockType": {
    "available": "空き",
    "blocked": "ブロック"
  },
  "appointmentTypes": {
    "followUp": "再診",
    "newPatient": "新患",
    "consultation": "相談",
    "procedure": "処置",
    "urgent": "緊急",
    "wellnessCheck": "健診",
    "physical": "身体検査",
    "telemedicine": "オンライン診療",
    "scheduleTemplate": "スケジュールテンプレート"
  },
  "pages": {
    "providerDirectory": {
      "title": "医療従事者ディレクトリ",
      "subtitle": "医療従事者を閲覧・検索",
      "search": {
        "namePlaceholder": "氏名で検索...",
        "specialtyPlaceholder": "専門で検索..."
      },
      "filters": {
        "facilityAriaLabel": "施設で絞り込み",
        "departmentAriaLabel": "診療科で絞り込み",
        "allFacilities": "すべての施設",
        "allDepartments": "すべての診療科"
      },
      "loading": "医療従事者を読み込み中...",
      "loadError": "医療従事者ディレクトリの読み込みに失敗しました。",
      "empty": "条件に一致する医療従事者は見つかりませんでした。",
      "npiLabel": "NPI:"
    },
    "scheduleTemplateForm": {
      "title": "スケジュールテンプレートを作成",
      "labels": {
        "provider": "担当医",
        "dayOfWeek": "曜日",
        "startTime": "開始時刻",
        "endTime": "終了時刻",
        "slotDuration": "枠の長さ(分)",
        "templateName": "テンプレート名",
        "effectiveStartDate": "有効開始日"
      },
      "slotDurationOption": "{{minutes}}分",
      "buttons": {
        "cancel": "キャンセル",
        "save": "テンプレートを保存"
      },
      "toast": {
        "success": "スケジュールテンプレートを保存しました",
        "failure": "スケジュールテンプレートの保存に失敗しました"
      },
      "placeholders": {
        "templateName": "例：月曜午前診療"
      },
      "defaultName": "{{day}}のスケジュール"
    },
    "scheduleManagement": {
      "title": "スケジュール管理",
      "backToDashboard": "← ダッシュボード",
      "newTemplate": "新規テンプレート",
      "today": "今日",
      "blockTooltip": "{{start}} - {{end}} ({{state}})",
      "slotsLabel": "{{minutes}}分の枠",
      "legend": {
        "booked": "予約済み"
      },
      "upcomingAppointmentsHeading": "今後の予約 - {{providerName}}",
      "loadingAppointments": "予約を読み込み中...",
      "unknownPatient": "不明な患者",
      "fallbackAppointmentType": "一般",
      "noUpcomingAppointments": "この医師の今後の予約はありません"
    },
    "providerCoverage": {
      "title": "代理対応",
      "subtitle": "期間限定の代理対応 — 一定期間、同僚に担当患者を引き継ぎます。緊急時の特例アクセスとは別物で、休暇・オンコール輪番・予定外不在に使用します。",
      "actions": {
        "newCoverage": "新規代理対応",
        "cancel": "キャンセル"
      },
      "form": {
        "title": "新しい代理対応の登録",
        "labels": {
          "coveredProviderId": "対象医師",
          "coveringProviderId": "代理医師",
          "scope": "範囲",
          "from": "開始",
          "until": "終了",
          "reason": "理由"
        },
        "placeholders": {
          "coveredProviderId": "担当患者を引き継いでもらう医師",
          "coveringProviderId": "この期間に代理を務める医師",
          "reason": "例: 4月22–29日 年次休暇、週末オンコール"
        },
        "help": {
          "coveredProviderId": "COVERAGE_ADMIN権限がない場合、ご自身を選択する必要があります。",
          "coveringProviderId": "名前で検索して選択してください — 入力されたIDにカバレッジが付与されることはありません。"
        },
        "aria": {
          "effectiveFromDate": "開始日",
          "effectiveFromTime": "開始時刻",
          "effectiveUntilDate": "終了日",
          "effectiveUntilTime": "終了時刻"
        },
        "buttons": {
          "cancel": "キャンセル",
          "create": "代理対応を登録"
        },
        "typeaheadEmpty": "担当医が見つかりません"
      },
      "sections": {
        "mine": {
          "title": "自分の代理対応",
          "subtitle": "自分が代理または被代理となっている代理対応。",
          "empty": "登録された代理対応はありません。"
        },
        "all": {
          "title": "すべての代理対応",
          "subtitle": "組織内のすべての代理対応。管理者ビュー。",
          "empty": "代理対応はどこにもありません。良い知らせか、フィルタが古いかのいずれかです。"
        }
      },
      "list": {
        "coveringConnector": "が代理",
        "groups": {
          "active": "有効中 ({{count}})",
          "planned": "予定 / 過去 ({{count}})",
          "revoked": "取消済み ({{count}})"
        },
        "untilRevoked": "取消まで",
        "revokedPrefix": "取消日",
        "revokeTitle": "取消"
      },
      "revokeDialog": {
        "title": "代理対応を取り消しますか?",
        "description": "{{coveringProviderName}}は今後{{coveredProviderName}}の代理を行いません。記録は監査証跡に残ります。",
        "confirm": "取り消す",
        "reasonPlaceholder": "このカバーを終了する理由（任意）"
      },
      "toast": {
        "created": "代理対応を登録しました",
        "revoked": "代理対応を取り消しました",
        "invalid": "代理対応が無効です — 医師と日付を確認してください",
        "forbidden": "この医師に対する代理対応を作成する権限がありません",
        "createFailed": "代理対応の登録に失敗しました",
        "revokeFailed": "代理対応の取り消しに失敗しました"
      }
    },
    "appointments": {
      "title": "予約",
      "subtitle": "患者の予約をスケジュール・管理",
      "actions": {
        "refresh": "更新",
        "schedule": "予約をスケジュール",
        "arriveTitle": "来院を記録",
        "arriveAria": "{{patientName}}の来院を記録",
        "checkInTitle": "受付",
        "checkInAria": "{{patientName}}を受付",
        "rescheduleTitle": "予約変更",
        "rescheduleAria": "{{patientName}}の予約を変更",
        "cancelTitle": "キャンセル",
        "cancelAria": "{{patientName}}の予約をキャンセル",
        "checkedInLabel": "受付済み",
        "startVisitTitle": "診察開始",
        "startVisitAria": "{{patientName}}の診察を開始"
      },
      "weekNav": {
        "previous": "前週",
        "previousAria": "前週",
        "next": "翌週",
        "nextAria": "翌週"
      },
      "calendar": {
        "gridAria": "週間予約カレンダー",
        "timeColumn": "時刻",
        "loading": "スケジュールを読み込み中...",
        "cellAria": "{{dayLabel}} {{date}} {{time}}",
        "cellTitle": "{{patientName}} - {{appointmentType}} ({{status}})"
      },
      "upcoming": {
        "heading": "今後の予約",
        "empty": "今週の予約はありません",
        "durationMinutes": "{{minutes}}分",
        "columns": {
          "dateTime": "日時",
          "patient": "患者",
          "type": "種別",
          "provider": "担当医",
          "duration": "所要時間",
          "status": "ステータス",
          "actions": "操作"
        }
      },
      "toast": {
        "cancelled": "予約をキャンセルしました",
        "cancelFailed": "予約のキャンセルに失敗しました",
        "visitStarted": "診察を開始しました",
        "startVisitFailed": "診察を開始できませんでした",
        "arrivalRecorded": "来院を記録しました",
        "arrivalFailed": "来院を記録できませんでした"
      }
    },
    "appointmentForm": {
      "title": {
        "create": "新規予約",
        "edit": "予約の変更"
      },
      "labels": {
        "patient": "患者",
        "appointmentType": "予約種別",
        "provider": "担当医",
        "scheduledAt": "予約日時",
        "duration": "所要時間",
        "reason": "受診理由"
      },
      "placeholders": {
        "patientSearch": "氏名またはMRNで患者を検索...",
        "provider": "担当医氏名",
        "reason": "受診理由を簡潔に..."
      },
      "patientTypeahead": {
        "empty": "該当する患者が見つかりません"
      },
      "aria": {
        "appointmentDate": "予約日",
        "appointmentTime": "予約時間"
      },
      "durationOption": "{{minutes}} 分",
      "buttons": {
        "cancel": "キャンセル",
        "schedule": "予約する",
        "update": "予約を更新"
      },
      "toast": {
        "created": "予約を作成しました",
        "updated": "予約を更新しました",
        "createFailed": "予約の作成に失敗しました",
        "updateFailed": "予約の更新に失敗しました"
      },
      "validation": {
        "patientRequired": "患者を選択してください",
        "appointmentTypeRequired": "予約種別は必須です",
        "scheduledAtRequired": "日付と時間を入力してください",
        "durationInvalid": "所要時間は1～480分の範囲で入力してください",
        "providerRequired": "担当医を選択してください"
      },
      "providerTypeahead": {
        "empty": "担当医が見つかりません"
      },
      "loadingEdit": "予約を読み込んでいます…",
      "loadEditError": "この予約を読み込めませんでした。",
      "patientLocked": "再予約の際、患者を変更することはできません。"
    },
    "waitlist": {
      "title": "予約待ちリスト",
      "backToDashboard": "← ダッシュボード",
      "entryCount": "{{count}} 件",
      "searchPlaceholder": "患者名、MRN、メモで検索...",
      "clearSearchAria": "検索をクリア",
      "filters": {
        "allProviders": "すべての担当医",
        "allTypes": "すべての種類",
        "providerAriaLabel": "担当医で絞り込み",
        "typeAriaLabel": "予約種別で絞り込み"
      },
      "columns": {
        "patient": "患者",
        "provider": "担当医",
        "type": "種類",
        "priority": "優先度",
        "requestedDates": "希望日",
        "dateAdded": "登録日",
        "notes": "メモ",
        "actions": "操作",
        "reason": "理由"
      },
      "priority": {
        "urgent": "緊急",
        "routine": "通常",
        "flexible": "柔軟"
      },
      "actions": {
        "scheduleTitle": "予約を作成",
        "editPriorityTitle": "優先度を編集",
        "removeTitle": "待ちリストから削除"
      },
      "empty": "条件に一致する待ちリストの項目はありません",
      "loadFailed": "待機リストを読み込めませんでした。接続を確認して再試行してください。",
      "modal": {
        "title": "予約を作成",
        "closeAria": "閉じる",
        "providerLabel": "担当医:",
        "requestedLabel": "希望:",
        "dateTimeLabel": "予約日時 *",
        "dateAria": "予約日",
        "timeAria": "予約時間",
        "requestedWindow": "希望期間: {{start}} — {{end}}",
        "cancel": "キャンセル",
        "submit": "予約"
      },
      "toasts": {
        "removed": "待ちリストから削除しました",
        "priorityUpdated": "優先度を更新しました",
        "scheduled": "予約を作成し、待ちリストから削除しました",
        "dateTimeRequired": "日付と時刻を選択してください",
        "updateFailed": "待機リストの更新に失敗しました",
        "promoteOrphaned": "予約は作成されましたが、待機リストの項目を更新できませんでした。再試行する前にスケジュールを確認してください。"
      }
    },
    "checkIn": {
      "title": "患者を受付",
      "subtitle": "受付 — 保険・承認・自己負担金。患者は来院済みです。",
      "fields": {
        "insuranceId": "保険",
        "copayAmount": "自己負担金額",
        "copayCollected": "自己負担金受領",
        "authorizationNumber": "承認番号",
        "authorizationVerified": "承認確認済み"
      },
      "copayHint": "自己負担金を受領済みにすると、患者の口座に入金が記録されます。",
      "submit": "受付を完了",
      "cancel": "キャンセル",
      "toast": {
        "success": "患者を受付しました",
        "failed": "患者を受付できませんでした"
      }
    },
    "providerTypeahead": {
      "loadError": "医師ディレクトリを利用できません — 接続を確認して再試行してください。",
      "retry": "再試行"
    }
  }
}
